import serviceProvider from './service-provider'

export default {
  // apiURL: 'http://localhost:3000',
  // apiURL: 'http://www.enviosweb.dev:3000',
  apiURL: 'https://www.enviosweb.com.mx',
  serviceProvider
}



// WEBPACK FOOTER //
// ./src/commons/index.js